import Onboarding from './Onboarding';
import PpvDashboard from './PpvDashboard';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import ThreatPanel from '../components/ThreatPanel';
import ThreatNetwork from '../components/ThreatNetwork';
import supabase from '../lib/supabase';
const API = 'https://tribaltech-backend.onrender.com';

function Sidebar() {
  const location = useLocation();
  const nav = [
    { path: '/dashboard', label: 'Dashboard',  icon: '▦' },
    { path: '/dashboard?tab=vault', label: 'My Vault', icon: '◈' },
    { path: '/leaks',    label: 'Leaks',      icon: '⚠' },
    { path: '/upload',   label: 'Upload',     icon: '↑' },
    { path: '/settings', label: 'Settings',   icon: '⚙' },
    { path: '/review',   label: 'Needs Review', icon: '⚠' },
    { path: '/insights',   label: 'Insights',    icon: '📊' },
    { path: '/analytics', label: 'Analytics',   icon: '🔍' },
    { path: '/tracker',  label: 'Takedowns',  icon: '⊟' },
    { path: '/help',     label: 'Help',       icon: '?' },
    { path: '/pricing',  label: 'Upgrade',    icon: '★' },
  ];
function ChangePasswordForm() {
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  async function handleChange() {
    setMsg(''); setError('');
    if (newPass !== confirm) return setError('Passwords do not match');
    if (newPass.length < 8) return setError('Password must be at least 8 characters');

    const token = localStorage.getItem('tribal_token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/change-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ currentPassword: current, newPassword: newPass })
    });
    const data = await res.json();
    if (!res.ok) setError(data.error || 'Failed to update password');
    else setMsg('Password updated successfully');
  }

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '1.5rem', maxWidth: 400 }}>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Change password</h3>
      <input type="password" placeholder="Current password" value={current} onChange={e => setCurrent(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14, marginBottom: 10, boxSizing: 'border-box' }} />
      <input type="password" placeholder="New password" value={newPass} onChange={e => setNewPass(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14, marginBottom: 10, boxSizing: 'border-box' }} />
      <input type="password" placeholder="Confirm new password" value={confirm} onChange={e => setConfirm(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14, marginBottom: 12, boxSizing: 'border-box' }} />
      {error && <p style={{ fontSize: 13, color: '#dc2626', marginBottom: 8 }}>{error}</p>}
      {msg && <p style={{ fontSize: 13, color: '#16a34a', marginBottom: 8 }}>{msg}</p>}
      <button onClick={handleChange}
        style={{ width: '100%', padding: '10px', borderRadius: 8, background: '#111', color: '#fff', border: 'none', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
        Update password
      </button>
    </div>
  );
}
  const user = JSON.parse(localStorage.getItem('tribal_user') || '{}');

  return (
    <div className="sidebar">
      <div className="sidebar-logo">CREATOR PROTECT</div>
      <nav className="sidebar-nav">
        {nav.map(n => {
          // Match on path + query so /dashboard vs /dashboard?tab=vault
          // pick the right entry. Fall back to pathname-only for the
          // simple entries.
          const currentFull = location.pathname + (location.search || '');
          const isVaultLink = n.path.includes('tab=vault');
          const isExactFullMatch = currentFull === n.path;
          const isPlainDashboard = n.path === '/dashboard'
            && location.pathname === '/dashboard'
            && !new URLSearchParams(location.search).get('tab');
          const isOtherMatch = !isVaultLink && n.path !== '/dashboard'
            && location.pathname === n.path;
          const active = isExactFullMatch || isPlainDashboard || isOtherMatch;
          return (
            <Link key={n.path} to={n.path} className={active ? 'active' : ''}>
              <span style={{ fontSize: 16 }}>{n.icon}</span>
              {n.label}
            </Link>
          );
        })}
      </nav>
      <div style={{ marginTop:'auto', padding:'20px', borderTop:'1px solid var(--border)' }}>
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 4 }}>{user.email}</div>
        <div
          style={{ fontSize: 12, color: 'var(--purple-light)', cursor:'pointer' }}
          onClick={() => { localStorage.clear(); window.location.href = '/login'; }}
        >
          Sign out
        </div>
        <ThreatPanel />
        <ThreatNetwork />
      </div>
    </div>
  );
}
function TabsBar({ active, onSelect }) {
  const tabs = [
    { id: 'protection', label: 'Leak protection' },
    { id: 'vault',      label: 'My Vault' },
  ];
  return (
    <div style={{
      display: 'flex', gap: 4, marginBottom: 24,
      borderBottom: '1px solid var(--border)',
    }}>
      {tabs.map(t => {
        const on = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => onSelect(t.id)}
            style={{
              background: 'transparent',
              border: 'none',
              color: on ? '#fff' : '#94a3b8',
              fontSize: 14,
              fontWeight: on ? 600 : 400,
              padding: '10px 18px',
              cursor: 'pointer',
              borderBottom: on ? '2px solid var(--purple-light, #a78bfa)' : '2px solid transparent',
              marginBottom: -1,
              transition: 'color 0.15s',
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export default function Dashboard() {
  // Onboarding popup: re-enabled to gate on § 512(c)(3) DMCA-profile
  // completeness (stage_name + original_content_source). Any creator
  // whose /api/settings/onboarding-status returns .complete=false gets
  // the modal on mount. Existing incomplete rows (like Nordic before
  // the 2026-07-10 backfill) drop straight to the missing step. This
  // closes the gap where a paid creator could reach the dashboard
  // with a profile that would silently fail every DMCA filing.
  const [showOnboarding, setShowOnboarding] = useState(false);
  // telegram_hits/telegram_last removed — no backend route exists
  // for Telegram detection yet. Re-add the fields (and the fetch
  // below) once the Telegram scanner + /api/leaks/telegram ship.
  const [stats, setStats]   = useState({ leaks: 0, dmca: 0, protected: 0, fingerprinted: 0 });
  const [leaks, setLeaks]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [scanStatus, setScanStatus] = useState(null);
  const [revenue, setRevenue] = useState(null);
  // Tabs: ?tab=vault renders the PPV dashboard content inline.
  // Default (no query) is the leak-protection view. The sidebar's
  // Dashboard link stays at /dashboard so the query param is what
  // drives the selected tab.
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'vault' ? 'vault' : 'protection';
  function selectTab(t) {
    if (t === 'protection') setSearchParams({});
    else setSearchParams({ tab: t });
  }
<button
  onClick={handleSignOut}
  style={{ fontSize: 13, padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', color: '#374151' }}
>
  Sign out
</button>
  const token = localStorage.getItem('tribal_token');
  const headers = { Authorization: 'Bearer ' + token };

  const loadDashboard = async () => {
    try {
      const [leaksRes, watermarksRes, revenueRes] = await Promise.all([
        axios.get(API + '/api/leaks', { headers }),
        axios.get(API + '/api/watermarks', { headers }),
        axios.get(API + '/api/analytics/revenue-recovery', { headers }).catch(() => ({ data: null })),
      ]);
      setRevenue(revenueRes.data);
      const leaksData = leaksRes.data || [];
      const wData     = watermarksRes.data || [];
      setLeaks(leaksData.slice(0, 5));
      setStats({
        leaks:         leaksData.length,
        dmca:          leaksData.filter(l => l.dmca_filed).length,
        protected:     wData.length,
        fingerprinted: wData.length,
      });
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => { loadDashboard(); }, []);

  // Check onboarding completeness (DMCA profile fields + usernames).
  // Fires once on mount. Any error is treated as "assume complete" so
  // a transient outage of the endpoint can't wall off a healthy creator
  // from the dashboard. The gate is best-effort; the DMCA renderer
  // still refuses to file if the profile is incomplete at fire time.
  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(API + '/api/settings/onboarding-status', { headers });
        if (r.data && r.data.complete === false) setShowOnboarding(true);
      } catch (_) { /* non-fatal — leave modal closed */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Poll the onboarding scan job if one is pending. Refreshes the
  // dashboard once the scan finishes so any newly-inserted leaks
  // land in the stats/table without requiring a manual reload.
  useEffect(() => {
    const jobId = localStorage.getItem('pending_scan_id');
    if (!jobId) return;

    let cancelled = false;
    let timer;

    const poll = async () => {
      if (cancelled) return;
      try {
        const r = await axios.get(API + '/api/scans/' + jobId + '/status', { headers });
        if (cancelled) return;
        setScanStatus(r.data);
        if (r.data.status === 'completed' || r.data.status === 'failed') {
          localStorage.removeItem('pending_scan_id');
          if (r.data.status === 'completed' && r.data.leaks_found > 0) loadDashboard();
          return;
        }
        timer = setTimeout(poll, 3000);
      } catch (e) {
        if (e.response?.status === 404) {
          localStorage.removeItem('pending_scan_id');
          return;
        }
        timer = setTimeout(poll, 3000);
      }
    };
    poll();

    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, []);

  const statusBadge = (dmca) => dmca
    ? <span className="badge badge-green">DMCA Filed</span>
    : <span className="badge badge-red">Pending</span>;

  return (
    <>
    {showOnboarding && <Onboarding creatorId={JSON.parse(localStorage.getItem('tribal_user') || '{}').id} onComplete={() => { localStorage.setItem('onboarding_complete', '1'); setShowOnboarding(false); }} />}
    <div className="page">
      <Sidebar />
      <div className="main">
        {activeTab === 'vault' ? (
          <>
            <TabsBar active={activeTab} onSelect={selectTab} />
            <PpvDashboard />
          </>
        ) : (
          <>
        <div className="page-title">Dashboard</div>
        <TabsBar active={activeTab} onSelect={selectTab} />

        {scanStatus && (scanStatus.status === 'pending' || scanStatus.status === 'running') && (
          <div style={{
            background: 'linear-gradient(90deg, #1e1b4b, #0f172a)',
            border: '1px solid #7c3aed', borderRadius: 12,
            padding: '14px 20px', marginBottom: 20,
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <span style={{ fontSize: 20 }}>🔍</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>
                Checking Google for existing leaks…
              </div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
                {(scanStatus.usernames_scanned || 0)} of {(scanStatus.usernames || []).length} username
                {(scanStatus.usernames || []).length === 1 ? '' : 's'} checked
                {scanStatus.leaks_found > 0 && ` · ${scanStatus.leaks_found} new leak${scanStatus.leaks_found === 1 ? '' : 's'} found`}
                {' · Broader scan across all platforms runs tonight at 3am'}
              </div>
            </div>
          </div>
        )}

        {scanStatus && scanStatus.status === 'completed' && (
          <div style={{
            background: 'rgba(34, 197, 94, 0.08)',
            border: '1px solid rgba(34, 197, 94, 0.3)', borderRadius: 12,
            padding: '14px 20px', marginBottom: 20,
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <span style={{ fontSize: 20, color: '#22c55e' }}>✓</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>Initial scan complete</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
                Checked {scanStatus.usernames_scanned} username{scanStatus.usernames_scanned === 1 ? '' : 's'}
                {scanStatus.leaks_found > 0
                  ? ` · ${scanStatus.leaks_found} existing leak${scanStatus.leaks_found === 1 ? '' : 's'} added to your list`
                  : ' · no existing leaks found'}
              </div>
            </div>
            <button onClick={() => setScanStatus(null)} style={{
              background: 'transparent', border: 'none', color: '#94a3b8',
              cursor: 'pointer', fontSize: 18,
            }}>×</button>
          </div>
        )}

        {scanStatus && scanStatus.status === 'failed' && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.08)',
            border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: 12,
            padding: '14px 20px', marginBottom: 20,
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <span style={{ fontSize: 20 }}>⚠</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>Initial scan failed</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
                The nightly scan at 3am will still run. {scanStatus.error || ''}
              </div>
            </div>
            <button onClick={() => setScanStatus(null)} style={{
              background: 'transparent', border: 'none', color: '#94a3b8',
              cursor: 'pointer', fontSize: 18,
            }}>×</button>
          </div>
        )}

        <div className="stat-grid">
          <div className="stat-card">
            <div className="stat-label">Leaks detected</div>
            <div className="stat-value" style={{ color:'var(--coral)' }}>{stats.leaks}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">DMCAs filed</div>
            <div className="stat-value" style={{ color:'var(--green)' }}>{stats.dmca}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Videos protected</div>
            <div className="stat-value" style={{ color:'var(--purple-light)' }}>{stats.protected}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Files fingerprinted</div>
            <div className="stat-value" style={{ color:'var(--gold)' }}>{stats.fingerprinted}</div>
          </div>
          {/* Telegram hits card removed — backend route doesn't
              exist yet. Re-add once the Telegram scanner ships. */}
        </div>

        {revenue && (
          <div className="card" style={{ marginBottom: 20 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom: 12 }}>
              <h3 style={{ fontSize: 16, margin: 0 }}>💰 Revenue at risk</h3>
              <span style={{ fontSize: 11, color:'var(--muted)' }}>this month vs last</span>
            </div>
            <div style={{ display:'flex', alignItems:'baseline', gap: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 32, fontWeight: 700, color:'var(--coral)' }}>
                ${Number(revenue.this_month?.total_loss || 0).toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2})}
              </div>
              <div style={{ fontSize: 13, color:'var(--muted)' }}>
                estimated · {revenue.this_month?.leak_count || 0} leak{revenue.this_month?.leak_count === 1 ? '' : 's'}
              </div>
              {revenue.change_pct != null && (
                <div style={{ fontSize: 13, color: revenue.change_pct >= 0 ? 'var(--coral)' : 'var(--green)' }}>
                  {revenue.change_pct >= 0 ? '↑' : '↓'} {Math.abs(revenue.change_pct).toFixed(1)}% vs last month (${Number(revenue.last_month?.total_loss || 0).toLocaleString(undefined,{maximumFractionDigits:0})})
                </div>
              )}
            </div>

            {revenue.this_month?.by_platform?.length > 0 && (
              <div>
                <div style={{ fontSize: 12, color:'var(--muted)', marginBottom: 8 }}>By platform</div>
                {revenue.this_month.by_platform.slice(0, 5).map((p, i) => {
                  const max = revenue.this_month.by_platform[0]?.loss || 1;
                  const pct = Math.max(4, (p.loss / max) * 100);
                  return (
                    <div key={i} style={{ display:'flex', alignItems:'center', gap: 10, marginBottom: 6 }}>
                      <div style={{ width: 160, fontSize: 13, color:'var(--text)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.platform}</div>
                      <div style={{ flex: 1, height: 8, background:'rgba(255,255,255,0.04)', borderRadius: 4 }}>
                        <div style={{ width: pct + '%', height: '100%', background:'var(--purple-light)', borderRadius: 4 }} />
                      </div>
                      <div style={{ width: 90, fontSize: 13, textAlign:'right', color:'var(--text)' }}>
                        ${Number(p.loss).toLocaleString(undefined,{maximumFractionDigits:0})}
                      </div>
                      <div style={{ width: 50, fontSize: 11, textAlign:'right', color:'var(--muted)' }}>
                        {p.leaks}×
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div style={{ fontSize: 11, color:'var(--muted)', marginTop: 12, paddingTop: 10, borderTop:'1px solid rgba(255,255,255,0.04)' }}>
              ⓘ Estimates using {(revenue.settings?.conversion_rate * 100 || 0.5).toFixed(2)}% conversion rate and
              ${Number(revenue.settings?.avg_ppv_price || 15).toFixed(0)} average PPV. Not actual revenue — rough signal only.
            </div>
          </div>
        )}

        <div className="card">
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 16 }}>
            <h3 style={{ fontSize: 16 }}>Recent leaks</h3>
            <Link to="/leaks" style={{ fontSize: 13 }}>View all →</Link>
          </div>

          {loading ? (
            <div style={{ color:'var(--muted)', fontSize: 14 }}>Loading...</div>
          ) : leaks.length === 0 ? (
            <div style={{ color:'var(--muted)', fontSize: 14, padding: '20px 0', textAlign:'center' }}>
              No leaks detected yet. The crawler runs every Monday automatically.
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>URL</th>
                  <th>Platform</th>
                  <th>Detected</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {leaks.map((leak, i) => (
                  <tr key={i}>
                    <td>
                      <a href={leak.leaked_url} target="_blank" rel="noreferrer"
                        style={{ fontSize: 12, color:'var(--purple-light)' }}>
                        {leak.leaked_url?.substring(0,60)}...
                      </a>
                    </td>
                    <td style={{ fontSize: 12, color:'var(--muted)' }}>
                      {leak.leaked_url?.split('/')[2] || 'Unknown'}
                    </td>
                    <td style={{ fontSize: 12, color:'var(--muted)' }}>
                      {leak.detected_at ? new Date(leak.detected_at).toLocaleDateString() : '—'}
                    </td>
                    <td>{statusBadge(leak.dmca_filed)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
          </>
        )}
      </div>
    </div>
    </>
  );
}

export { Sidebar };
async function handleSignOut() {
  await supabase.auth.signOut();
  window.location.href = '/login';
}
